module.exports = __webpack_public_path__ + "static/img/MM@3x.6f7c20c1.jpg";